import { render } from "./NonTariffMeasure.vue?vue&type=template&id=1d36b2a2"
import script from "./NonTariffMeasure.vue?vue&type=script&lang=js"
export * from "./NonTariffMeasure.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__